var React = require('react');

function Bang6 (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n"),React.createElement("rect",{"x":"245.6","y":"356.7","transform":"matrix(0.8118 -0.584 0.584 0.8118 -168.2296 254.1948)","className":"st0","width":"129.3","height":"62.7","key":1})]);
}

Bang6.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 612 792","style":{"enableBackground":"new 0 0 612 792"},"xmlSpace":"preserve"};

module.exports = Bang6;

Bang6.default = Bang6;
